import { render, staticRenderFns } from "./tool-edit-info-issues.vue?vue&type=template&id=19cbad89&scoped=true&"
import script from "./tool-edit-info-issues.vue?vue&type=script&lang=js&"
export * from "./tool-edit-info-issues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cbad89",
  null
  
)

export default component.exports